"use client"

import { useState, useEffect, useRef } from "react"
import { X } from "lucide-react"
import "./InfoModal.css"

// Este componente muestra una vista previa del perfil
const InfoModal = ({ isOpen, onClose }) => {
    const [isMobile, setIsMobile] = useState(false)
    const imageContainerRef = useRef(null)

    useEffect(() => {
        // Detectar si es dispositivo móvil
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768)
        }

        // Verificar al inicio y cuando cambia el tamaño de pantalla
        checkMobile()
        window.addEventListener("resize", checkMobile)

        // Guardar el estado original del overflow
        const originalOverflow = document.body.style.overflow;

        // Desactivar scroll cuando el modal está abierto
        if (isOpen) {
            document.body.style.overflow = "hidden"

            // Asegurarnos que el scroll empiece desde arriba cuando se abre el modal
            if (imageContainerRef.current) {
                setTimeout(() => {
                    if (imageContainerRef.current) {
                        imageContainerRef.current.scrollTop = 0
                    }
                }, 50)
            }
        }

        // Limpiar listeners y restaurar scroll al desmontar o cerrar
        return () => {
            window.removeEventListener("resize", checkMobile)
            // Solo restauramos a auto si ese era su valor original o si isOpen estaba activo
            if (originalOverflow || isOpen) {
                document.body.style.overflow = originalOverflow || "auto"
            }
        }
    }, [isOpen])

    if (!isOpen) return null

    // Función para detener la propagación de eventos
    const stopPropagation = (e) => {
        e.stopPropagation()
    }

    return (
        <div className="info-modal-overlay" onClick={onClose}>
            <div className="info-modal-content" onClick={stopPropagation}>
                <button className="info-modal-close-btn" onClick={onClose} aria-label="Cerrar">
                    <X size={24} />
                </button>

                <div
                    className="info-modal-image-container"
                    ref={imageContainerRef}
                >
                    {isMobile ? (
                        <img
                            src="/images/profile-preview-mobile.png"
                            alt="Vista previa del perfil en móvil"
                            className="info-modal-image"
                        />
                    ) : (
                        <img
                            src="/images/profile-preview-desktop.png"
                            alt="Vista previa del perfil en escritorio"
                            className="info-modal-image"
                        />
                    )}
                </div>

                <div className="info-modal-disclaimer">
                    <p>Así se vería tu perfil en CONTACTAME. Esta imagen es ilustrativa.</p>
                </div>
            </div>
        </div>
    )
}

export default InfoModal